module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-info flexRow"
  }, [(!_vm.isValidCategory) ? _c('div') : _c('div', {
    class: _vm.isMobile() ? 'flexRow' : ''
  }, [_c('div', {
    staticClass: "metadata flexRow"
  }, [_c('div', {
    staticClass: "block",
    style: (_vm.blockColorString)
  }), _vm._v(" "), _c('div', {
    staticClass: "metadataHeader flexRow"
  }, [_c('div', [_c('span', [_vm._v("\n            " + _vm._s(_vm.getCategoryName(_vm.categoryId)) + "\n          ")]), _vm._v(" "), _c('edit-category-trigger', {
    staticClass: "editIcon",
    attrs: {
      "categoryId": _vm.categoryId
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "lastBlock"
  }, [_vm._v("\n          " + _vm._s(_vm.timeSinceLastBlock) + "\n        ")])])]), _vm._v(" "), (!_vm.isMobile()) ? _c('div', {
    staticClass: "categoryStats flexRow"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n        Blocks\n      ")]), _vm._v(" "), _vm._l((_vm.categoryTotals), function(count, timeframe) {
    return _c('div', {
      staticClass: "countBlock"
    }, [_c('div', {
      staticClass: "blockCount"
    }, [_vm._v("\n          " + _vm._s(count) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "timeframe"
    }, [_vm._v("\n          " + _vm._s(timeframe) + "\n        ")])])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.isValidCategory && !_vm.isMobile()) ? _c('block-graph', {
    attrs: {
      "categoryId": _vm.categoryId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44aa2ed8!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/CategoryDetails.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-44aa2ed8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/CategoryDetails.vue
// module chunks = 0